import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

var DatePicker = function DatePicker(_ref) {
  var disabled = _ref.disabled,
      dsOnChange = _ref.dsOnChange,
      locale = _ref.locale,
      utils = _ref.utils,
      e2e = _ref.e2e,
      error = _ref.error,
      format = _ref.format,
      fullWidth = _ref.fullWidth,
      helperText = _ref.helperText,
      label = _ref.label,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      value = _ref.value,
      required = _ref.required;
  format = format || 'MM/DD/YYYY';
  utils = utils || MomentUtils;
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(MuiPickersUtilsProvider, {
      locale: locale,
      utils: utils
    }, /*#__PURE__*/React.createElement(KeyboardDatePicker, _extends({
      clearable: true,
      disabled: disabled,
      error: error,
      format: format,
      fullWidth: fullWidth,
      inputVariant: "outlined",
      helperText: helperText,
      label: label,
      minDate: minDate,
      maxDate: maxDate,
      onChange: dsOnChange,
      required: required,
      size: "small",
      value: value
    }, e2e && {
      'data-e2e': e2e,
      inputProps: {
        'data-e2e': "".concat(e2e, "-input")
      },
      InputLabelProps: {
        'data-e2e': "".concat(e2e, "-label")
      }
    })))
  );
};

export default DatePicker;

try {
  DatePicker.__docgenInfo = {
    description: '',
    displayName: 'DatePicker',
    methods: [],
    props: {
      dsOnChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnChange',
        required: true,
        type: {
          name: '(date: Moment, value?: string) => void'
        }
      },
      locale: {
        defaultValue: null,
        description: '',
        name: 'locale',
        required: false,
        type: {
          name: 'any'
        }
      },
      utils: {
        defaultValue: null,
        description: '',
        name: 'utils',
        required: false,
        type: {
          name: 'any'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      format: {
        defaultValue: null,
        description: '',
        name: 'format',
        required: true,
        type: {
          name: 'string'
        }
      },
      minDate: {
        defaultValue: null,
        description: '',
        name: 'minDate',
        required: false,
        type: {
          name: 'ParsableDate'
        }
      },
      maxDate: {
        defaultValue: null,
        description: '',
        name: 'maxDate',
        required: false,
        type: {
          name: 'ParsableDate'
        }
      },
      disabled: {
        defaultValue: null,
        description: 'Disable picker and text field\n' + 'If `true`, the `input` element will be disabled.',
        name: 'disabled',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      fullWidth: {
        defaultValue: null,
        description: 'If `true`, the input will take up the full width of its container.',
        name: 'fullWidth',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      error: {
        defaultValue: null,
        description: 'If `true`, the label will be displayed in an error state.',
        name: 'error',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      label: {
        defaultValue: null,
        description: 'The label content.',
        name: 'label',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      value: {
        defaultValue: null,
        description: 'Picker value',
        name: 'value',
        required: true,
        type: {
          name: 'ParsableDate'
        }
      },
      required: {
        defaultValue: null,
        description: 'If `true`, the label is displayed as required and the `input` element` will be required.',
        name: 'required',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      helperText: {
        defaultValue: null,
        description: 'The helper text content.',
        name: 'helperText',
        required: false,
        type: {
          name: 'ReactNode'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map